{
  "common": {
    "cancel": "Cancel·la",
    "save": "Desa",
    "delete": "Elimina",
    "done": "Fet",
    "edit": "Edita",
    "search": "Cerca",
    "loading": "Carregant…",
    "yes": "Sí",
    "no": "No",
    "settings": "Configuració",
    "back": "Enrere",
    "close": "Tanca",
    "open": "Obre",
    "copy": "Copia",
    "restore": "Restaura",
    "untitled": "Sense títol",
    "create": "Crea",
    "revoke": "Revoca",
    "never": "Mai",
    "tryAgain": "Torna-ho a provar",
    "reload": "Recarrega",
    "update": "Actualitza",
    "insert": "Insereix",
    "loadingShort": "S'està carregant",
    "unknown": "Desconegut",
    "sampleSentence": "La guineu marró ràpida"
  },
  "sidebar": {
    "views": "Vistes",
    "tags": "Etiquetes",
    "edit": "Edita",
    "done": "Fet",
    "account": "Compte",
    "newNote": "Nota nova",
    "editTag": "Edita l'etiqueta",
    "tagOptions": "Opcions de l'etiqueta",
    "reorder": "Reordena {{label}}",
    "showView": "Mostra {{label}}",
    "hideView": "Amaga {{label}}",
    "editViews": "Edita les vistes",
    "doneEditingViews": "Acaba d'editar",
    "samplePeep": "Caliu és…",
    "sampleQuiet": "Un lloc tranquil on les teves idees poden viure i respirar."
  },
  "views": {
    "all": "Totes les notes",
    "today": "Avui",
    "todo": "Tasques",
    "pinned": "Fixades",
    "untagged": "Sense etiquetes",
    "thisWeek": "Aquesta setmana",
    "shared": "Compartides per mi",
    "sharedWithMe": "Compartides amb mi",
    "attachments": "Adjunts",
    "trash": "Paperera",
    "archive": "Arxivades"
  },
  "noteList": {
    "empty": "Encara no hi ha notes",
    "emptySubtitle": "Crea la primera per començar.",
    "untitled": "Sense títol",
    "selectNote": "Selecciona una nota",
    "selectNoteHint": "Tria una nota de la llista o crea'n una de nova.",
    "selectRestoreOrDelete": "Selecciona una nota per restaurar-la o eliminar-la definitivament",
    "selectSharedToView": "Selecciona una nota compartida per veure-la",
    "searchPlaceholder": "Cerca notes…",
    "selectNotes": "Selecciona notes",
    "openSidebar": "Obre la barra lateral",
    "cancelSelection": "Cancel·la la selecció",
    "clearSelection": "Neteja la selecció",
    "emptyTrash": "Buida la paperera",
    "newNote": "Nota nova",
    "noteCount_one": "{{count}} nota",
    "noteCount_other": "{{count}} notes",
    "sortBy": "Ordena per",
    "preview": "Previsualització",
    "modificationDate": "Data de modificació",
    "creationDate": "Data de creació",
    "title": "Títol",
    "manual": "Manual",
    "newestOnTop": "Més recents a dalt",
    "small": "Petita",
    "medium": "Mitjana",
    "large": "Gran",
    "empty_pinned": "Encara no hi ha res fixat",
    "empty_pinned_subtitle": "Fixa una nota per trobar-la ràpid aquí.",
    "empty_today": "Avui no s'ha editat res",
    "empty_today_subtitle": "Les notes que toquis avui apareixeran aquí.",
    "empty_todo": "Encara no hi ha tasques",
    "empty_todo_subtitle": "Les notes amb tasques obertes apareixeran aquí.",
    "empty_untagged": "Tot està etiquetat",
    "empty_untagged_subtitle": "Les notes sense etiquetes apareixeran aquí.",
    "empty_thisWeek": "Res aquesta setmana",
    "empty_thisWeek_subtitle": "Les notes editades els últims 7 dies apareixeran aquí.",
    "empty_shared": "Cap nota compartida",
    "empty_shared_subtitle": "Les notes que comparteixis apareixeran aquí.",
    "empty_attachments": "Encara no hi ha adjunts",
    "empty_attachments_subtitle": "Les notes amb imatges o fitxers apareixeran aquí.",
    "justNow": "Ara mateix",
    "minutesAgo": "fa {{count}} min",
    "today": "Avui",
    "yesterday": "Ahir",
    "deletedOn": "Eliminada el {{date}}",
    "newNoteShortcut": "Nota nova ({{shortcut}})",
    "noContent": "Sense contingut",
    "selectUnarchiveOrDelete": "Selecciona una nota per desarxivar-la o eliminar-la",
    "view": "Visualització",
    "density": "Densitat",
    "exportAll": "Exporta-ho tot"
  },
  "editor": {
    "attachmentTooLarge": "Aquest fitxer és massa gran per adjuntar-lo. El límit és 100 MB.",
    "placeholder": "Comença a escriure…",
    "noMatchingCommands": "Cap comanda coincident",
    "newNote": "nota nova",
    "noResults": "Sense resultats",
    "foldSection": "Plega la secció",
    "unfoldSection": "Desplega la secció",
    "dragSection": "Mou la secció",
    "presenceLabel": "També aquí: {{names}}"
  },
  "noteActions": {
    "pin": "Fixa",
    "unpin": "Desfixa",
    "pinToTop": "Fixa a dalt",
    "makeReadOnly": "Fer només de lectura",
    "makeEditable": "Fer editable",
    "readOnlyNote": "Nota només de lectura",
    "shareNote": "Comparteix la nota",
    "share": "Comparteix",
    "publiclyShared": "Compartida públicament",
    "privateNote": "Nota privada",
    "linkCreated": "Enllaç creat",
    "linkCreatedAndCopied": "Enllaç creat i copiat",
    "linkRevoked": "Enllaç de compartició revocat",
    "failedToCreateShareLink": "No s'ha pogut crear l'enllaç de compartició",
    "failedToRevokeShareLink": "No s'ha pogut revocar l'enllaç de compartició",
    "thisNoteIsPrivate": "Aquesta nota és privada.",
    "createPublicLink": "Crea enllaç públic",
    "creatingLink": "Creant enllaç…",
    "revokeLink": "Revoca l'enllaç",
    "revokingLink": "Revocant…",
    "copyLink": "Copia l'enllaç",
    "copyNoteId": "Copia l'ID de la nota",
    "noteIdCopied": "ID de la nota copiat",
    "exportAs": "Exporta com a",
    "exportMarkdown": "Markdown",
    "exportPlainText": "Text pla",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "L'exportació ha fallat",
    "viewHistory": "Mostra l'historial",
    "duplicate": "Duplica",
    "duplicateFailed": "No s'ha pogut duplicar la nota",
    "select": "Selecciona",
    "delete": "Elimina",
    "moveToTrash": "Mou a la paperera",
    "archive": "Arxiva",
    "unarchive": "Desarxiva",
    "tags": "Etiquetes",
    "addTag": "Afegeix una etiqueta",
    "noTagsYet": "Encara no hi ha etiquetes",
    "addTagFailed": "No s'ha pogut afegir l'etiqueta",
    "removeTagFailed": "No s'ha pogut treure l'etiqueta"
  },
  "userMenu": {
    "theme": "Tema",
    "typography": "Tipografia",
    "language": "Idioma",
    "apiKeys": "Claus d'API",
    "devices": "Dispositius",
    "connectedApps": "Apps connectades",
    "help": "Ajuda",
    "logOut": "Tanca la sessió",
    "defaultUserName": "Usuari de Caliu",
    "editName": "Edita el nom",
    "nameLabel": "Nom",
    "namePlaceholder": "El teu nom",
    "upgradeToPro": "Millora a Caliu Pro",
    "replayOnboarding": "Torna a veure la introducció",
    "logOutTitle": "Vols tancar la sessió?",
    "logOutBody": "Les teves notes es queden en aquest dispositiu i les pots continuar llegint i escrivint. Torna a iniciar la sessió per sincronitzar.",
    "logOutPending_one": "{{count}} canvi encara no s'ha sincronitzat. Es queda en aquest dispositiu fins que tornis a iniciar la sessió.",
    "logOutPending_other": "{{count}} canvis encara no s'han sincronitzat. Es queden en aquest dispositiu fins que tornis a iniciar la sessió.",
    "logOutKeep": "Tanca la sessió",
    "logOutAndRemove": "Tanca la sessió i elimina les notes"
  },
  "help": {
    "title": "Centre d'ajuda",
    "searchPlaceholder": "Cerca articles d'ajuda",
    "noResults": "Cap article coincideix amb la teva cerca.",
    "offline": "L'ajuda no està disponible sense connexió. Es carregarà la propera vegada que estiguis connectat."
  },
  "fonts": {
    "uiFont": "Tipus de la interfície",
    "body": "Cos",
    "headings": "Títols",
    "code": "Codi",
    "sans": "Sans",
    "serif": "Serif",
    "mono": "Mono",
    "editor": "Editor",
    "ui": "Interfície",
    "reset": "Restableix"
  },
  "themes": {
    "light": "Clar",
    "dark": "Fosc",
    "system": "Sistema"
  },
  "languages": {
    "systemHint": "Detectat del teu dispositiu",
    "names": {
      "en": "Anglès",
      "es": "Espanyol",
      "ca": "Català",
      "fr": "Francès",
      "de": "Alemany",
      "it": "Italià",
      "pt": "Portuguès",
      "nl": "Neerlandès",
      "ja": "Japonès",
      "zh-CN": "Xinès (simplificat)",
      "ko": "Coreà",
      "zh-TW": "Xinès (tradicional)",
      "ru": "Rus"
    }
  },
  "bulkActions": {
    "pinSelected": "Fixa les seleccionades",
    "unpinSelected": "Desfixa les seleccionades",
    "pin": "Fixa",
    "addTag": "Afegeix etiqueta",
    "filterTags": "Filtra etiquetes…",
    "noTagsFound": "No s'han trobat etiquetes",
    "exportSelected": "Exporta seleccionades",
    "restoreSelected": "Restaura seleccionades",
    "deletePermanently": "Elimina definitivament",
    "moveToTrash": "Mou a la paperera",
    "archiveSelected": "Arxiva la selecció",
    "unarchiveSelected": "Desarxiva la selecció",
    "exportingTitle": "Exportant les teves notes",
    "exportingBody": "Això pot trigar una mica. Mantén aquesta pestanya oberta fins que acabi.",
    "exportingProgress": "{{done}} de {{total}}"
  },
  "commandPalette": {
    "placeholder": "Cerca notes, etiquetes, comandes…",
    "noResults": "Cap resultat per a «{{query}}»",
    "currentNote": "Nota actual",
    "navigation": "Navegació",
    "notes": "Notes",
    "tags": "Etiquetes",
    "newNote": "Nota nova",
    "allNotes": "Totes les notes",
    "todaysNotes": "Notes d'avui",
    "todo": "Tasques",
    "pinnedNotes": "Notes fixades",
    "trash": "Paperera",
    "importNotes": "Importa notes",
    "changeTheme": "Canvia el tema",
    "keyboardShortcuts": "Dreceres de teclat",
    "pinNote": "Fixa la nota",
    "unpinNote": "Desfixa la nota",
    "restoreNote": "Restaura la nota",
    "copyShareLink": "Copia l'enllaç de compartició",
    "makePrivate": "Fes-la privada",
    "toggleFullscreen": "Pantalla completa",
    "noteInfo": "Informació de la nota",
    "moveToTrash": "Mou a la paperera",
    "archiveNote": "Arxiva la nota",
    "unarchiveNote": "Desarxiva la nota",
    "archive": "Arxivades"
  },
  "noteHistory": {
    "title": "Historial de la nota",
    "requiresConnection": "L'historial de notes requereix connexió.",
    "reconnect": "Connecta't a Internet i torna-ho a provar.",
    "noHistory": "Encara no hi ha historial per a aquesta nota.",
    "windowMerged": "Les edicions dins d'una finestra de 5 minuts es combinen en una sola entrada.",
    "selectVersion": "Selecciona una versió per previsualitzar",
    "encrypted": "Captura xifrada",
    "encryptedHint": "Aquesta versió es va desar amb xifratge d'extrem a extrem. Obre la nota per veure el contingut actual.",
    "restoreVersion": "Vols restaurar aquesta versió?",
    "restoreVersionHint": "Això substituirà el contingut actual de la nota per la versió del {{date}}.",
    "current": "Actual",
    "created": "Creada",
    "trashed": "Eliminada",
    "restored": "Restaurada",
    "edited": "Editada"
  },
  "apiKeys": {
    "title": "Claus d'API",
    "empty": "Encara no hi ha claus d'API.",
    "emptyHint": "Crea'n una per començar a fer servir l'API.",
    "created": "Creada el {{date}}",
    "lastUsed": "Últim ús: {{date}}",
    "revokeKey": "Revoca la clau",
    "viewApiDocs": "Veure la documentació de l'API",
    "newApiKey": "Nova clau d'API",
    "apiKeyCreated": "Clau d'API creada",
    "createApiKey": "Crea una clau d'API",
    "copyHint": "Copia aquesta clau ara. No la podràs tornar a veure.",
    "copyToClipboard": "Copia al porta-retalls",
    "keyName": "Nom de la clau",
    "keyNamePlaceholder": "p. ex. El meu script, Integració Zapier",
    "createKey": "Crea la clau",
    "revokeKeyTitle": "Revoca la clau d'API",
    "revokeKeyHint": "Això revocarà definitivament aquesta clau d'API. Qualsevol aplicació que la utilitzi perdrà l'accés immediatament.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "Apps connectades",
    "empty": "Encara no hi ha apps connectades.",
    "emptyHint": "Connecta Claude, ChatGPT o un altre assistent d'IA per fer servir les teves notes des del xat. La secció Caliu amb IA d'Ajuda explica com fer-ho.",
    "connected": "Connectada el {{date}}",
    "lastUsed": "Últim ús: {{date}}",
    "revoke": "Revoca",
    "revokeTitle": "Revoca la connexió",
    "revokeHint": "Això revocarà l'accés de <strong>{{name}}</strong> al teu compte de Caliu i eliminarà les credencials que feia servir. Perdrà l'accés immediatament.",
    "thisApp": "aquesta app",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "Escriptura",
    "metadata": "Metadades",
    "words": "Paraules",
    "characters": "Caràcters",
    "paragraphs": "Paràgrafs",
    "readTime": "Temps de lectura",
    "minutes": "{{count}} min",
    "tags": "Etiquetes",
    "outgoingLinks": "Enllaços de sortida",
    "backlinks": "Retroenllaços",
    "created": "Creada",
    "modified": "Modificada",
    "noteStatistics": "Estadístiques de la nota",
    "identifier": "Identificador"
  },
  "inspector": {
    "tabInfo": "Info",
    "tabOutline": "Esquema",
    "tabHistory": "Historial",
    "dates": "Dates",
    "noHeadings": "No hi ha capçaleres en aquesta nota",
    "noBacklinks": "Cap nota enllaça aquí",
    "noOutgoing": "Aquesta nota no enllaça a res",
    "noAttachments": "No hi ha adjunts en aquesta nota",
    "historyOffline": "L'historial de versions necessita connexió",
    "historyLoadMore": "Carrega més"
  },
  "devices": {
    "title": "Dispositius",
    "offline": "Estàs sense connexió.",
    "offlineHint": "Connecta't a Internet per veure els teus dispositius.",
    "noSessions": "No s'han trobat sessions actives.",
    "thisDevice": "Aquest dispositiu",
    "lastUsed": "Últim ús: {{date}}",
    "created": "Creat: {{date}}",
    "signOutCurrent": "Tanca la sessió en aquest dispositiu",
    "signOut": "Tanca la sessió",
    "confirmCurrentTitle": "Vols tancar la sessió en aquest dispositiu?",
    "confirmRevokeTitle": "Vols revocar el dispositiu?",
    "confirmCurrentBody": "Es tancarà la sessió de Caliu en aquest navegador i les notes s'eliminaran d'aquest dispositiu. Torna a iniciar la sessió quan vulguis i tornaran des del teu compte.",
    "confirmRevokeBody": "Es tancarà la sessió del dispositiu immediatament. Els canvis sense sincronitzar es mantindran fins que tornis a iniciar sessió.",
    "revoke": "Revoca"
  },
  "errorScreen": {
    "title": "Hi ha hagut un problema",
    "defaultMessage": "S'ha produït un error inesperat. Prova a recarregar la pàgina."
  },
  "importModal": {
    "title": "Importa notes",
    "dropToImport": "Deixa anar per importar",
    "dropOrClick": "Deixa anar fitxers o fes clic per buscar",
    "removeFile": "Treu el fitxer",
    "keepNote": "Per a Google Keep, exporta un ZIP de Takeout i puja aquest arxiu directament.",
    "importedCount_one": "S'ha importat <strong>{{count}}</strong> nota",
    "importedCount_other": "S'han importat <strong>{{count}}</strong> notes",
    "fromSource": " des de {{source}}",
    "importing": "S'està important…",
    "importN": "Importa {{count}} fitxers",
    "importBtn": "Importa"
  },
  "share": {
    "shareNote": "Comparteix la nota",
    "publiclySharedAria": "La nota es comparteix públicament",
    "copyLink": "Copia l'enllaç",
    "revokingLink": "S'està revocant…",
    "revokeLink": "Revoca l'enllaç",
    "creatingLink": "S'està creant l'enllaç…",
    "createPublicLink": "Crea un enllaç públic",
    "shareThisNotePublicly": "Comparteix aquesta nota públicament",
    "thisNoteIsPrivate": "Aquesta nota és privada.",
    "publiclyShared": "Compartida públicament",
    "privateNote": "Nota privada"
  },
  "shortcuts": {
    "searchPlaceholder": "Cerca dreceres…",
    "pressNew": "Prem la nova drecera…",
    "resetToDefault": "Restableix al valor predeterminat",
    "noMatches": "No hi ha dreceres que coincideixin amb «<strong>{{query}}</strong>»",
    "navigate": "navegar",
    "edit": "edita",
    "closeAction": "tanca",
    "resetAll": "Restableix-ho tot"
  },
  "tagEditor": {
    "icon": "Icona",
    "color": "Color",
    "searchIcons": "Cerca icones",
    "noIcons": "Cap icona coincideix",
    "categories": {
      "essentials": "Bàsiques",
      "work": "Feina i tecnologia",
      "ideas": "Idees i creativitat",
      "life": "Persones i llar",
      "travel": "Viatges i natura",
      "fun": "Menjar, salut i lleure"
    }
  },
  "tagActions": {
    "pin": "Fixa l'etiqueta",
    "unpin": "Desfixa l'etiqueta",
    "rename": "Canvia el nom…",
    "renameTitle": "Canvia el nom de l'etiqueta",
    "renameConfirm": "Canvia el nom",
    "renameHint": "L'etiqueta s'actualitza a totes les notes que la fan servir, incloses les arxivades i les de la paperera.",
    "renamed": "S'ha canviat el nom de l'etiqueta",
    "nameInUse": "Aquest nom ja està en ús",
    "invalidName": "Els noms d'etiqueta només poden tenir lletres, números, espais, guions i guions baixos",
    "pinFailed": "No s'ha pogut actualitzar l'etiqueta",
    "renameFailed": "No s'ha pogut canviar el nom de l'etiqueta",
    "editAppearance": "Edita l'aparença"
  },
  "auth": {
    "appName": "Caliu",
    "or": "o",
    "email": "Correu electrònic",
    "emailPlaceholder": "tu@exemple.com",
    "password": "Contrasenya",
    "passwordPlaceholder": "Contrasenya",
    "name": "Nom",
    "namePlaceholder": "El teu nom",
    "confirmPassword": "Confirma la contrasenya",
    "newPassword": "Nova contrasenya",
    "confirmNewPassword": "Confirma la nova contrasenya",
    "signInSubtitle": "Inicia la sessió al teu compte",
    "createAccountSubtitle": "Crea el teu compte",
    "forgotPassword": "Has oblidat la contrasenya?",
    "signingIn": "S'està iniciant la sessió…",
    "signIn": "Inicia la sessió",
    "noAccount": "No tens cap compte?",
    "signUp": "Crea un compte",
    "haveAccount": "Ja tens un compte?",
    "creatingAccount": "S'està creant el compte…",
    "createAccount": "Crea el compte",
    "googleSignUpAria": "Registra't amb Google",
    "signupClosedTitle": "El registre està tancat per ara",
    "signupClosedBody": "Caliu està en beta privada. Apunta't a la llista d'espera a caliuapp.com per aconseguir accés anticipat.",
    "joinWaitlist": "Apunta't a la llista d'espera",
    "forgotTitle": "Restableix la contrasenya",
    "forgotSubtitle": "Introdueix el correu i t'enviarem un enllaç per restablir-la.",
    "sendResetLink": "Envia l'enllaç de restabliment",
    "sending": "S'està enviant…",
    "checkYourEmail": "Revisa el teu correu",
    "resetLinkSentPrefix": "Si ",
    "resetLinkSentSuffix": " té un compte, t'hem enviat un enllaç per restablir la contrasenya. Caduca en 1 hora.",
    "backToSignIn": "Torna a iniciar sessió",
    "verifySentPrefix": "Hem enviat un enllaç de verificació a ",
    "verifySentSuffix": ". Fes-hi clic per activar el compte.",
    "linkExpires10m": "L'enllaç caduca en 10 minuts.",
    "resending": "S'està reenviant…",
    "resendEmail": "Reenvia el correu",
    "wrongEmail": "Correu equivocat?",
    "goBack": "Torna",
    "invalidResetLinkTitle": "Enllaç de restabliment no vàlid",
    "invalidResetLinkBody": "Aquest enllaç no és vàlid o ha caducat.",
    "requestNewLink": "Demana un enllaç nou",
    "setNewPasswordTitle": "Estableix la nova contrasenya",
    "setNewPasswordHint": "Tria una contrasenya segura.",
    "updatingPassword": "S'està actualitzant…",
    "updatePassword": "Actualitza la contrasenya",
    "localNotesTitle": "Tens notes en aquest dispositiu",
    "localNotesBody_one": "Has escrit {{count}} nota aquí abans d'iniciar la sessió. Què en fem?",
    "localNotesBody_other": "Has escrit {{count}} notes aquí abans d'iniciar la sessió. Què en fem?",
    "localNotesDelete": "Elimina-les",
    "localNotesMerge": "Afegeix-les al meu compte",
    "backToMyNotes": "Torna a les meves notes",
    "errorGoogleAuthFailed": "No s'ha pogut iniciar la sessió amb Google. Torna-ho a provar.",
    "errorInvalidToken": "Enllaç de verificació no vàlid. Registra't de nou.",
    "errorEmailTaken": "Aquest correu ja està en ús. Inicia la sessió.",
    "signInInstead": "Inicia la sessió en aquell compte",
    "errorIdentityTaken": "Aquesta identitat ja pertany a un altre compte de Caliu. Inicia-hi la sessió.",
    "parkedNotesTitle": "Notes d'un altre compte",
    "parkedNotesBody_one": "Inicia la sessió a {{email}} per conservar-ne les notes en aquest dispositiu. Un altre compte esborrarà l'única nota que hi ha aquí, incloent-hi el que s'hi hagi escrit després.",
    "parkedNotesBody_other": "Inicia la sessió a {{email}} per conservar-ne les notes en aquest dispositiu. Un altre compte esborrarà les {{count}} notes que hi ha aquí, incloent-hi el que s'hi hagi escrit després.",
    "parkedNotesBodyNoEmail_one": "Inicia la sessió al compte del qual has tancat la sessió per conservar-ne les notes en aquest dispositiu. Un altre compte esborrarà l'única nota que hi ha aquí, incloent-hi el que s'hi hagi escrit després.",
    "parkedNotesBodyNoEmail_other": "Inicia la sessió al compte del qual has tancat la sessió per conservar-ne les notes en aquest dispositiu. Un altre compte esborrarà les {{count}} notes que hi ha aquí, incloent-hi el que s'hi hagi escrit després.",
    "parkedNotesContinue": "Continua"
  },
  "connectors": {
    "wantsAccess": "vol accedir a Caliu",
    "couldntLoad": "No s'ha pogut carregar la sol·licitud",
    "authorize": "Autoritza",
    "keepHappeningHint": "Si això continua passant, elimina el connector del teu client MCP i torna a afegir-lo.",
    "backToCaliu": "Torna a Caliu",
    "askingPermissionPrefix": "demana permís per llegir i modificar les teves notes i etiquetes a través del servidor MCP de Caliu.",
    "signedInAs": "Sessió iniciada com a {{name}}.",
    "permissions": "Permisos",
    "deny": "Denega",
    "allow": "Permet"
  },
  "editorTypography": {
    "fontSize": "Mida de la lletra",
    "lineHeight": "Alçada de línia",
    "paragraphSpacing": "Espai entre paràgrafs"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Maj"
  },
  "floatingMenu": {
    "undo": "Desfés",
    "redo": "Refés",
    "taskList": "Llista de tasques",
    "bulletList": "Llista amb pics",
    "orderedList": "Llista numerada",
    "blockQuote": "Citació en bloc",
    "separator": "Separador",
    "insertTag": "Insereix etiqueta",
    "highlight": "Ressaltar",
    "math": "Fórmula",
    "removeHighlight": "Treure el ressaltat",
    "inlineCode": "Codi en línia",
    "codeBlock": "Bloc de codi",
    "insertTable": "Insereix taula",
    "insertImage": "Insereix imatge",
    "hideStyleBar": "Amaga la barra d'estils",
    "attachFile": "Adjunta un fitxer",
    "photoLibrary": "Fototeca",
    "camera": "Càmera",
    "fromFile": "Des d'un fitxer"
  },
  "imageDialog": {
    "title": "Insereix imatge",
    "tabUpload": "Fitxer",
    "tabUrl": "URL",
    "urlLabel": "URL de la imatge",
    "urlPlaceholder": "https://exemple.com/imatge.jpg",
    "altLabel": "Text alternatiu",
    "altPlaceholder": "Descriu la imatge…",
    "previewAlt": "vista prèvia",
    "changeImage": "Canvia la imatge",
    "dropToInsert": "Deixa anar per inserir",
    "dropOrClick": "Deixa anar una imatge o fes clic per buscar",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "Insereix imatge"
  },
  "linkDialog": {
    "editTitle": "Edita l'enllaç",
    "insertTitle": "Insereix l'enllaç",
    "textLabel": "Text",
    "textPlaceholder": "Text de l'enllaç",
    "urlPlaceholder": "https://exemple.com",
    "removeLink": "Treu l'enllaç",
    "openLink": "Obre l'enllaç",
    "editLink": "Edita l'enllaç"
  },
  "noteEditor": {
    "notFound": "No s'ha trobat la nota.",
    "inTrashBanner": "Aquesta nota és a la paperera. Restaura-la per editar-la.",
    "restore": "Restaura",
    "noContent": "Aquesta nota no té contingut."
  },
  "noteHeader": {
    "noteInfo": "Informació de la nota"
  },
  "table": {
    "deleteRow": "Suprimeix fila",
    "deleteTable": "Suprimeix taula",
    "addRow": "Afegeix fila",
    "addRowAbove": "Afegeix fila a dalt",
    "addColumn": "Afegeix columna",
    "addColumnBefore": "Afegeix columna abans",
    "moveRowUp": "Mou fila amunt",
    "moveRowDown": "Mou fila avall",
    "moveColumnLeft": "Mou columna a l'esquerra",
    "moveColumnRight": "Mou columna a la dreta",
    "deleteColumn": "Elimina la columna",
    "actions": "Accions de taula"
  },
  "syncIndicator": {
    "synced": "Sincronitzat",
    "pending_one": "{{count}} canvi pendent",
    "pending_other": "{{count}} canvis pendents",
    "offline": "Sense connexió",
    "offlinePending_one": "Sense connexió · {{count}} pendent",
    "offlinePending_other": "Sense connexió · {{count}} pendents",
    "syncing": "S'està sincronitzant...",
    "conflict_one": "{{count}} conflicte",
    "conflict_other": "{{count}} conflictes",
    "error": "Error de sincronització",
    "syncedTooltip": "Tots els canvis desats",
    "pendingTooltip_one": "{{count}} canvi esperant per sincronitzar",
    "pendingTooltip_other": "{{count}} canvis esperant per sincronitzar",
    "offlineTooltip": "Sense connexió: els canvis se sincronitzaran en reconnectar",
    "offlinePendingTooltip_one": "Sense connexió: {{count}} canvi se sincronitzarà en reconnectar",
    "offlinePendingTooltip_other": "Sense connexió: {{count}} canvis se sincronitzaran en reconnectar",
    "syncingTooltip": "S'està sincronitzant...",
    "syncingPendingTooltip_one": "S'està sincronitzant {{count}} canvi pendent...",
    "syncingPendingTooltip_other": "S'està sincronitzant {{count}} canvis pendents...",
    "conflictTooltip_one": "{{count}} nota té canvis en conflicte. Fes clic per resoldre'ls.",
    "conflictTooltip_other": "{{count}} notes tenen canvis en conflicte. Fes clic per resoldre'ls.",
    "errorTooltip": "Ha fallat la sincronització. Es tornarà a provar automàticament.",
    "conflictsTitle": "Resoldre conflictes",
    "local": "En aquest dispositiu",
    "localTooltip": "Només en aquest dispositiu. Inicia la sessió per sincronitzar."
  },
  "image": {
    "download": "Descarrega la imatge",
    "replace": "Substitueix la imatge",
    "remove": "Treu la imatge"
  },
  "sharePage": {
    "goToCaliu": "Vés a Caliu",
    "noteNotFoundTitle": "Nota no trobada",
    "somethingWentWrong": "Hi ha hagut un problema",
    "lastUpdated": "Última actualització: {{date}}",
    "tagline": "Una app de notes per a qui pensa",
    "subtagline": "Escriu en markdown. Sincronitza-ho a tot arreu. Pensa amb claredat.",
    "startWriting": "Comença a escriure",
    "signIn": "Inicia la sessió",
    "openInCaliu": "Obre a Caliu",
    "adding": "S'està afegint…",
    "addToSharedList": "Afegeix a la meva llista compartida",
    "notFoundSubtitle": "Aquest enllaç pot haver caducat o haver estat revocat.",
    "errorSubtitle": "No s'ha pogut carregar aquesta nota. Torna-ho a provar."
  },
  "sharedView": {
    "loading": "S'està carregant la nota compartida…",
    "sharedWithYou": "Compartida amb tu",
    "viewRaw": "Mostra el Markdown en brut",
    "viewRendered": "Mostra la nota renderitzada",
    "copyMarkdown": "Copia el Markdown",
    "markdownCopied": "Markdown copiat",
    "copyFailed": "No s'ha pogut copiar",
    "notLoadedYet": "Aquesta nota encara no s'ha carregat",
    "linkCopied": "Enllaç copiat",
    "actions": "Accions de la nota"
  },
  "sharedWithMe": {
    "title": "Compartides amb mi",
    "removeFromList": "Treu de la llista",
    "empty": "Encara no hi ha notes compartides",
    "emptyHint": "Obre un enllaç compartit de Caliu d'un amic per afegir-lo aquí. Les notes compartides se sincronitzen entre els teus dispositius."
  },
  "trashView": {
    "empty": "La paperera és buida",
    "emptyHint": "Les notes eliminades apareixeran aquí",
    "retention": "Les notes de la paperera s'eliminen definitivament al cap de 30 dies",
    "trash": "Paperera"
  },
  "fileAttachment": {
    "download": "Baixa el fitxer",
    "remove": "Elimina el fitxer"
  },
  "archiveView": {
    "archive": "Arxivades",
    "empty": "L'arxiu és buit",
    "emptyHint": "Les notes arxivades apareixeran aquí",
    "archivedOn": "Arxivada el {{date}}"
  },
  "pro": {
    "subtitle": "Caliu, sense límits.",
    "features": [
      "Notes il·limitades",
      "Historial de versions de notes",
      "Exporta a PDF, HTML, RTF, ePub + en lot",
      "Tots els temes, tipografies i icones d'app",
      "Dona suport al desenvolupament de Caliu"
    ],
    "perMonth": "{{price}} al mes",
    "perWeek": "{{price}} a la setmana",
    "oneTime": "{{price}} pagament únic",
    "perYear": "{{price}} a l'any",
    "or": "o",
    "signInToSubscribe": "Inicia la sessió per subscriure't",
    "accountRequired": "Caliu Pro està vinculat al teu compte, així que es desbloqueja a tots els teus dispositius.",
    "plansUnavailable": "No hem pogut carregar els plans. Comprova la connexió i torna-ho a provar.",
    "yearly": "Anual",
    "monthly": "Mensual",
    "continue": "Continua",
    "bestValue": "Millor opció",
    "autoRenew": "{{amount}}. Es renova automàticament fins que el cancel·lis. Cancel·la quan vulguis.",
    "freeTrial": "Gratis durant {{count}} dies",
    "billedSubtitle": "Gratis durant {{count}} dies, després {{amount}}. Cancel·la quan vulguis.",
    "startTrial": "Comença la prova gratuïta",
    "upgradeSubtitle": "Historial de versions, tots els temes i tipografies, exportació i molt més.",
    "upgradeNow": "Millora ara",
    "thanks": "Gràcies per donar suport a Caliu!",
    "renewsOn": "Es renova el {{date}}",
    "endsOn": "Acaba el {{date}}",
    "lifetime": "Accés per a tota la vida",
    "lifetimePlan": "Per a tota la vida",
    "oneTimeNoRenewal": "Pagament únic",
    "launchPrice": "Preu de llançament. Més endavant pujarà a {{price}}.",
    "buy": "Compra",
    "oneTimeDisclosure": "{{amount}}. Pagament únic, sense renovació.",
    "thanksMessage": "El teu suport manté Caliu independent i privat.",
    "manageSubscription": "Gestiona la subscripció",
    "contactUs": "Dubtes? Escriu-nos",
    "grandfatheredNote": "Com a impulsor inicial, Caliu Pro és teu per sempre. No has de renovar res.",
    "webFootnote": "L'exportació a PDF encara no està disponible al web.",
    "active": "Activa"
  },
  "find": {
    "placeholder": "Cerca a la nota",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "Cap resultat",
    "next": "Coincidència següent",
    "previous": "Coincidència anterior",
    "close": "Tanca"
  },
  "conflicts": {
    "description": "Aquesta nota s'ha editat en un altre dispositiu. Conserva'n una versió.",
    "yours": "La teva versió",
    "theirs": "La seva versió",
    "step": "{{current}} de {{total}}",
    "keepYours": "Conserva la teva",
    "keepTheirs": "Conserva la seva",
    "serverError": "No s'ha pogut carregar l'altra versió.",
    "done": "Tots els conflictes resolts.",
    "previous": "Conflicte anterior",
    "next": "Conflicte següent",
    "copyOf": "Còpia de {{title}}"
  },
  "onboarding": {
    "welcomeTitle": "Et donem la benvinguda a Caliu",
    "welcomeSubtitle": "Un lloc tranquil on les teves idees poden viure i respirar.",
    "getStarted": "Comença",
    "magicTitle": "Mira com les teves paraules prenen forma",
    "magicSubtitle": "Tu escrius text pla. Caliu el converteix en estructura: tasques, ressaltats i etiquetes que s'ordenen soles.",
    "magicLearnMore": "Aprèn els fonaments de Markdown",
    "replay": "Repeteix",
    "demoTitle": "Estiu vora el mar",
    "demoBody": "Planejar una **setmana tranquil·la** en un poble petit.",
    "demoTask": "Reservar la caseta",
    "demoHighlight": "Nedar ==abans== d'esmorzar",
    "demoTags": "#estiu #plans",
    "intentTitle": "Què hi portaràs, aquí?",
    "intentSubtitle": "Tria'n uns quants. La teva primera nota i les etiquetes t'estaran esperant, ja teves.",
    "themeTitle": "Tria la teva llum",
    "themeSubtitle": "Temes per acompanyar el to de la teva escriptura.",
    "proTitle": "Comença amb tot",
    "proSubtitle": "Comença amb tot des del primer dia. Prova'l gratis i queda-te'l només si es guanya el seu lloc.",
    "proTrust": "Sense anuncis. Sense trucs. Cancel·la quan vulguis.",
    "tryProFree": "Prova Pro gratis",
    "continueFree": "Continua amb el pla gratuït",
    "allSetTitle": "Tot a punt",
    "allSetSubtitle": "Benvingut a Caliu. Fes-lo teu.",
    "startWriting": "Comença a escriure",
    "firstNoteTitle": "On tot comença",
    "firstNoteBody": "Aquesta és la meva primera nota. Viu en aquest dispositiu, funciona sense connexió i em segueix a tot arreu.",
    "firstNoteTask": "Apuntar una idea que valgui la pena guardar",
    "next": "Següent",
    "skip": "Omet",
    "back": "Enrere",
    "intents": {
      "journal": "Diari",
      "ideas": "Idees",
      "work": "Feina",
      "study": "Estudis",
      "reading": "Lectura",
      "plans": "Plans"
    },
    "signInCta": "Inicia sessió o registra't",
    "continueWithoutAccount": "Continua sense compte",
    "backupTitle": "On viuen les teves notes",
    "backupSubtitle": "Comencen en aquest dispositiu. Amb un compte se sincronitzen, així una còpia segura arriba a tots els teus dispositius.",
    "syncOffTitle": "La sincronització està desactivada",
    "syncOffBody": "Inicia la sessió per sincronitzar les teves notes a tots els dispositius.",
    "backupSignedIn": "Les teves notes se sincronitzen de manera segura mentre escrius.",
    "backupStageDevice": "Aquest dispositiu",
    "backupStageSafe": "Sincronitzades",
    "backupStageEverywhere": "Tots els teus dispositius",
    "freeNotes": "{{limit}} notes gratis, sense compte, per sempre. Pro les fa il·limitades."
  },
  "backup": {
    "evictionNotice": "De moment les notes viuen només en aquest navegador. Els navegadors poden esborrar les dades del lloc si falta espai.",
    "dismiss": "Descarta",
    "signIn": "Inicia la sessió"
  },
  "gate": {
    "share": "Inicia la sessió per compartir notes.",
    "history": "Inicia la sessió per desar l'historial de versions.",
    "import": "Inicia la sessió per importar notes."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "Codi LaTeX"
  },
  "noteLimit": {
    "banner": "{{count}} de {{limit}} notes",
    "paywallTitle": "Has arribat a les {{limit}} notes gratuïtes",
    "paywallBody": "Editar, cercar i sincronitzar continuen funcionant. Envia una nota a la paperera per alliberar un lloc, o passa a il·limitat amb Caliu Pro: mensual, anual o amb una compra única per a tota la vida.",
    "importCapped": "Només s'han importat {{count}} de {{total}} fitxers: el pla gratuït permet {{limit}} notes."
  },
  "appUpdate": {
    "available": "Hi ha una nova versió de Caliu disponible."
  },
  "settings": {
    "title": "Configuració",
    "account": "Compte",
    "writing": "Escriptura",
    "keyboardShortcuts": "Dreceres de teclat",
    "editor": "Editor",
    "yourNotes": "Les teves notes",
    "about": "Quant a",
    "noAccount": "Sense compte",
    "sendFeedback": "Envia comentaris",
    "signInOrCreate": "Inicia sessió o registra't",
    "notesComeWithYou": "Les notes d'aquest dispositiu van amb tu.",
    "notSyncing": "Sense sincronitzar",
    "signInToSync": "Inicia la sessió per sincronitzar les teves notes.",
    "sync": "Sincronització",
    "security": "Seguretat",
    "communications": "Comunicacions",
    "newsletter": "Butlletí de Caliu",
    "newsletterFooter": "Un correu breu de tant en tant sobre les versions noves i el que arriba a Caliu.",
    "newsletterError": "No s'ha pogut actualitzar el butlletí. Torna-ho a provar.",
    "appearance": "Aparença",
    "themes": "Temes",
    "sizing": "Mida",
    "systemDefault": "Per defecte del sistema",
    "separateThemes": "Temes diferents per a clar i fosc",
    "maxWidth": "Amplada màxima",
    "maxWidthHint": "Centra el text en una columna llegible a les pantalles amples",
    "markdownReturn": "Retorn estil Markdown",
    "markdownReturnHint": "Retorn insereix un salt de línia. Prem Retorn dos cops per a un paràgraf nou",
    "newNoteStart": "Les notes noves comencen amb",
    "newNoteStartH1": "Encapçalament 1",
    "newNoteStartH2": "Encapçalament 2",
    "newNoteStartH3": "Encapçalament 3",
    "newNoteStartH4": "Encapçalament 4",
    "newNoteStartDate": "Data",
    "newNoteStartDateIso": "Data (ISO 8601)",
    "newNoteStartDateTime": "Data i hora",
    "newNoteStartDateTimeIso": "Data i hora (ISO 8601)",
    "newNoteStartEmpty": "Buida",
    "newNoteStartHint": "S'aplica a les notes que crees a l'app.",
    "collapsibleSections": "Seccions plegables",
    "collapsibleSectionsHint": "Permet plegar un encapçalament i el seu contingut darrere d'una fletxa",
    "experimental": "Experimental",
    "general": "General"
  },
  "toolbar": {
    "toggleSidebar": "Mostra o amaga la barra lateral",
    "toggleInspector": "Mostra o amaga l'inspector",
    "searchNotes": "Cerca a les notes",
    "newNote": "Nova nota",
    "findInNote": "Cerca a la nota",
    "showToolbar": "Mostra la barra d'eines",
    "hideToolbar": "Amaga la barra d'eines",
    "moreNoteActions": "Més accions per a la nota",
    "undo": "Desfés",
    "redo": "Refés",
    "zenMode": "Mode Zen",
    "sourceMode": "Mode font",
    "richEditor": "Editor enriquit",
    "sortBy": "Ordena per",
    "bold": "Negreta",
    "italic": "Cursiva",
    "heading": "Encapçalament",
    "list": "Llista",
    "link": "Enllaç",
    "insert": "Insereix",
    "more": "Més",
    "strikethrough": "Ratllat",
    "table": "Taula",
    "horizontalRule": "Línia horitzontal",
    "codeBlock": "Bloc de codi",
    "inlineCode": "Codi en línia",
    "blockQuote": "Cita",
    "math": "Fórmula",
    "highlight": "Ressaltat",
    "bulletList": "Llista amb pics",
    "orderedList": "Llista numerada",
    "photoLibrary": "Fototeca",
    "camera": "Càmera",
    "files": "Fitxers",
    "yellow": "Groc",
    "green": "Verd",
    "blue": "Blau",
    "pink": "Rosa",
    "purple": "Lila",
    "heading1": "Encapçalament 1",
    "heading2": "Encapçalament 2",
    "heading3": "Encapçalament 3",
    "heading4": "Encapçalament 4",
    "heading5": "Encapçalament 5",
    "heading6": "Encapçalament 6",
    "removeHighlight": "Treu el ressaltat"
  },
  "whatsNew": {
    "title": "Novetats",
    "tagIconsTitle": "Icones dibuixades per a Caliu",
    "tagIconsBody": "Totes les icones de l'app són noves i fetes per a Caliu. Dona a cada etiqueta la seva pròpia icona i cerca-les en el teu idioma.",
    "newNoteStartTitle": "Comença les notes a la teva manera",
    "newNoteStartBody": "Una nota nova pot començar amb un encapçalament, la data d'avui, la data i l'hora, o en blanc. Tria-ho a Configuració, a Editor.",
    "typographyTitle": "Tipografia, al punt exacte",
    "typographyBody": "Tria la mida exacta del text, l'alçada de línia i l'espai entre paràgrafs de les teves notes, a Configuració, a Tipografia.",
    "typographySample": "Cada nota segueix la mida, l'alçada de línia i l'espaiat que triïs, punt per punt.",
    "sampleMorningPages": "Pàgines del matí",
    "newsletterTitle": "Arriba el butlletí de Caliu",
    "newsletterBody": "A partir d'ara, un correu breu t'explica les novetats de cada versió, en el teu idioma. Activa'l si et ve de gust. Pots canviar-ho quan vulguis a Configuració."
  },
  "sharing": {
    "inviteByEmail": "Convida per correu",
    "invite": "Convida",
    "roleOwner": "Propietari",
    "roleEditor": "Pot editar",
    "roleViewer": "Pot veure",
    "generalAccess": "Accés general",
    "shareWithLink": "Comparteix amb un enllaç",
    "accessRestricted": "Només les persones convidades",
    "accessView": "Qualsevol persona amb l'enllaç pot veure",
    "accessEdit": "Qualsevol persona amb l'enllaç pot editar",
    "remove": "Treu",
    "leave": "Surt",
    "leaveNote": "Surt de la nota",
    "leaveConfirmTitle": "Vols sortir d'aquesta nota?",
    "leaveConfirmBody": "Desapareixerà de les teves llistes a tots els dispositius. El propietari et pot tornar a convidar.",
    "leaveSelectedTitle": "Vols sortir de les notes compartides?",
    "leaveSelectedBody_one": "Sortiràs de {{count}} nota compartida amb tu. Les teves notes aniran a la paperera.",
    "leaveSelectedBody_other": "Sortiràs de {{count}} notes compartides amb tu. Les teves notes aniran a la paperera.",
    "sharedBy": "Compartida per {{name}}",
    "sharedList": "Compartides",
    "viewOnly": "Només lectura",
    "accessNowEditor": "Ara pots editar aquesta nota.",
    "accessNowViewer": "Ara només pots veure aquesta nota.",
    "accessRemoved": "Ja no tens accés a aquesta nota.",
    "unsentSavedAsCopy": "Els canvis no enviats s'han desat en una còpia.",
    "privateNote": "Nota privada",
    "memberLimit": "Una nota es pot compartir amb un màxim de 50 persones.",
    "rateLimit": "Massa invitacions. Torna-ho a provar més tard.",
    "inviteFailed": "No s'han pogut enviar les invitacions. Torna-ho a provar.",
    "invalidEmail": "Introdueix una adreça de correu vàlida.",
    "onlineOnly": "Connecta't a internet per gestionar la compartició.",
    "you": "Tu",
    "ownerOnly": "Només el propietari pot canviar qui hi té accés.",
    "unavailable": "La compartició no està disponible ara mateix. Torna-ho a provar més tard.",
    "updateFailed": "No s'ha pogut actualitzar la compartició. Torna-ho a provar.",
    "inviteInvalid": "Aquesta invitació ja no és vàlida.",
    "copyLink": "Copia l'enllaç",
    "invited": "Convidat",
    "copied": "Copiat",
    "accessRestrictedHint": "Només la gent que convidis la pot obrir.",
    "onlyYouHint": "Només tu la pots obrir.",
    "accessViewHint": "Qualsevol amb l'enllaç la pot llegir, sense compte.",
    "accessEditHint": "Qualsevol amb l'enllaç la pot editar.",
    "roleBelowLink": "Qualsevol amb l'enllaç pot editar, així que la gent que convidis també pot editar.",
    "inviteAs": "Convidar com a",
    "revokeInvite": "Revocar la invitació",
    "statusPeople_one": "{{count}} persona",
    "statusPeople_other": "{{count}} persones",
    "publicLink": "Enllaç públic",
    "statusFrom": "De {{name}}",
    "removeConfirmTitle": "Vols treure {{name}}?",
    "removeConfirmBody": "Ja no tindrà accés a aquesta nota.",
    "revokeConfirmTitle": "Vols revocar la invitació a {{name}}?",
    "revokeConfirmBody": "L'enllaç de la invitació deixarà de funcionar.",
    "peopleWithAccess": "Persones amb accés",
    "addPeoplePlaceholder": "Afegeix persones per correu",
    "invitePro": "Convidar persones forma part de Caliu Pro.",
    "inviteKeepsAccess": "La gent convidada manté l'accés si desactives l'enllaç.",
    "youSuffix": "(tu)"
  },
  "noAccess": {
    "title": "No tens accés a aquesta nota",
    "linkBody": "El seu propietari no l'ha compartida amb tu. Demana-li que et convidi o que activi l'enllaç.",
    "signedOutBody": "Inicia la sessió amb el compte amb què es va compartir.",
    "inviteTitle": "Aquesta invitació ja no és vàlida",
    "inviteBody": "Demana'n una de nova a qui et va convidar.",
    "removedTitle": "Ja no tens accés a aquesta nota",
    "removedBody": "El seu propietari t'ha tret.",
    "removedCopyBody": "El seu propietari t'ha tret. Els canvis sense enviar s'han desat com una còpia a les teves notes.",
    "backToNotes": "Tornar a les notes",
    "signIn": "Inicia la sessió"
  }
}
